export default "__VITE_ASSET__CujGA0LE__"